import { Currency } from "../../../constants";
import {
  formatCurrencyInput,
  parseCurrencyInput,
} from "../../../utils/currency";

interface LocalWithdrawalInputProps {
  currency: Currency;
  amount: string;
  onAmountChange: (amount: string) => void;
  error?: string;
  isLoading?: boolean;
  balance?: number;
}

export function LocalWithdrawalInput({
  currency,
  amount,
  onAmountChange,
  error,
  isLoading = false,
  balance,
}: LocalWithdrawalInputProps) {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    const cleaned = parseCurrencyInput(rawValue);
    onAmountChange(cleaned);
  };

  const formattedAmount = amount ? formatCurrencyInput(amount) : "";

  return (
    <div className="local-withdrawal-input">
      <label className="block text-sm text-gray-600 mb-2">You send</label>

      <div
        className={`flex items-center border rounded-lg p-3 transition-all ${
          error
            ? "border-red-500 ring-2 ring-red-500/20"
            : "border-primary ring-2 ring-primary/20"
        }`}
      >
        <input
          id="local-withdrawal-input"
          type="text"
          inputMode="numeric"
          value={formattedAmount}
          onChange={handleInputChange}
          placeholder="0"
          className="flex-1 text-lg font-semibold outline-none bg-transparent"
          disabled={isLoading}
        />
        <span className="ml-2 text-gray-700 font-medium">{currency}</span>
      </div>

      {/* Balance Display */}
      <p className="text-xs text-gray-500 mt-1">
        Balance: {balance?.toLocaleString("en-US")} {currency}
      </p>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-3 mt-2 animate-slide-down">
          <p className="text-xs text-red-700">{error}</p>
        </div>
      )}
    </div>
  );
}
